export const WEB_CONTENT = {
    CHAT: {
      GROUP_INFO: {
         GROUP_MEMBERS : {
            TITLE: 'Group Members',
            ADD_MEMBER: 'Add Member',
            REMOVE_MEMBER: 'Remove Member',
            REMOVE: 'Remove', //only remove as name will be shown against remove
            MAKE_ADMIN: 'Make Admin',
            REMOVE_ADMIN: 'Remove Admin',
            BLOCK_MEMBER: 'Block Member',
            UNBLOCK_MEMBER: 'Unblock Member',
         }
      },
      GROUP_CAST: {
        CREATE_GROUP_CAST: 'Create Group Cast',
      }
    },
    ERROR_MESSAGES: {
      GENERIC_ERROR: "Something went wrong. Please try again.",
    },
    CONSENT_MESSAGES: {
      REMOVE_MEMBER: (name) => `Are you sure you want to remove ${name} from the group?`,
      CANCEL: 'Cancel',
      REMOVE: 'Remove',
      MAKE_ADMIN: (name) => `Are you sure you want to make ${name} an admin?`,
      REMOVE_ADMIN: (name) => `Are you sure you want to remove ${name} as admin?`,
    },
    MESSAGE_ACTIONS: {
      INFO: 'Message Info',
      FORWARD: 'Forward',
      REPLY: 'Reply',
      DELETE: 'Delete',
      DELETE_FOR_SELF: 'Delete for me',
      DELETE_FOR_EVERYONE: 'Delete for everyone',
    },
    CONVERSATION_ACTIONS: {
      CLEAR_CHAT: 'Clear Chat',
      CLOSE_CHAT: 'Close Chat',
      SEARCH_CHAT: 'Search Chat',
      BLOCK_CHAT: 'Block Chat',

    },
    PLACEHOLDER_CONTENT: {
      NO_CONTACTS_FOUND: {
        TITLE: 'No contacts found',
        DESCRIPTION: 'No users are available right now. Try refreshing the page or searching again after some time.',
      },
      SEARCH_CHAT: {
        NO_RESULTS_FOUND: 'No results found',
        SEARCH_FOR_MSG: "Search for messages",
        MESSAGE: 'Message',
      },
      SEARCH_FOR_NAME_OR_NUMBER: 'Search name or number',
      UNSUPPORTED_MEDIA: 'No images or videos found',
      LOADING:"Loading..."
    },
    POPUP_MESSAGES: {
      DELETE_LABEL: 'Delete Message?',
      SHARE_MEDIA_LABEL: 'Share Media',
    },
    REACTIONS: {
      REMOVE_REACTION_ON_TAP: 'Tap To Remove',
      REACTIONS_TAP_INFO: 'Tap on any tab to see list'
    },
    UNSUPPORTED_MEDIA_TYPES:'Unsupported media type',
    PLEASE_WAIT:"Please wait...",
    BLOCK_CHAT_MESSAGE:" Can't send a message to blocked contact ",
    LOGIN:'Log In',
    LOGIN_DESC:'Please enter your valid email address and password to log in',
    EMAIL:'Enter Email',
    PASSWORD:"Enter Password",
    LOG_IN:"Login"
    
  };
